module.exports = __webpack_public_path__ + "static/img/mf_code.3e125ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mf_code.png
// module id = uMK4
// module chunks = 94